import React from "react";
import { View, Text } from "@react-pdf/renderer";

const money = (n) => `$${Number(n).toFixed(2)}`;

export default function PaymentSection({ S, data }) {
  return (
    <View style={[S.box, { marginTop: 10 }]}>
      <Text style={S.label}>Forma de Pago: {data.metodoPago || "—"}</Text>

      <View style={{lexDirection: "row", justifyContent: "space-between" }}>
        <Text>{money(data.formaPagoMonto)}</Text> 
        <Text style={S.bold}>
          TOTAL PAGADO {money(data.totalPagado)}
        </Text>
      </View>

      <View
        style={{
          marginTop: 6,
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Text style={S.muted}>Vuelto</Text>
        <Text>{money(data.vuelto)}</Text>
      </View>
    </View>
  );
}